// extracted by mini-css-extract-plugin
export default {"rating":"JN-z","numberOfStars":"KN-z","count":"LN-z","barGraphSpacing":"MN-z","barGraph":"NN-z"};